module.exports = __webpack_public_path__ + "static/media/eng_d_2380.b12ca4dc.vtt";